import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  type SectionCreationMethod,
  type SectionEditorContext,
} from '@/models/analytics/features/notes';

/**
 * Shared `section_created` / `section_deleted` dispatch for the markdown-native
 * (MDNE) editor. A twin of the vMarkdown `section-analytics.ts`: centralising
 * the emit here means the four MDNE dispatch sites — the `# ` input rule, the
 * `/section` slash command, the convert-to-section bubble command and the
 * "Delete section" action — all stamp `editor_type: 'markdown_native'` from one
 * place, so a new site can't silently drift.
 *
 * Unlike the vMarkdown twin (which takes an `EditorType` and converts), MDNE
 * call sites already resolve the `editor_context` themselves, so these accept it
 * directly.
 */
export function trackSectionCreated(
  editorContext: SectionEditorContext,
  creationMethod: SectionCreationMethod
): void {
  track({
    event_name: TrackingEventName.SectionCreated,
    props: {
      creation_method: creationMethod,
      editor_context: editorContext,
      editor_type: 'markdown_native',
    },
    options: { amplitude: false },
  });
}

/** Fires `section_deleted` for a user-initiated delete in the MDNE editor. */
export function trackSectionDeleted(editorContext: SectionEditorContext): void {
  track({
    event_name: TrackingEventName.SectionDeleted,
    props: { editor_context: editorContext, editor_type: 'markdown_native' },
    options: { amplitude: false },
  });
}
